<template>
<div class="container">
    <div class="title">
        <span>设备及应用管理</span>
        <div class="title-tip">班主任和学校管理员同时具有修改学生终端配置权限，以最后修改配置为准</div>
    </div>
    <el-divider class="line"></el-divider>
    <div class="content">
        <div class="select-class">
            <el-select v-model="selectedGradeIdx" placeholder="选择年级" size="small" class="select-type-one" @change="onGradeChange">
                <el-option
                v-for="item in gradeList"
                :key="item.Idx"
                :label="item.Name"
                :value="item.Idx">
                </el-option>
            </el-select>
            <el-select v-model="selectedClassIdx" placeholder="选择班级" size="small" class="select-type-one" @change="onClassChange">
                <el-option
                v-for="item in classList"
                :key="item.Idx"
                :label="item.Name"
                :value="item.Idx">
                </el-option>
            </el-select>
        </div>
        <!-- 终端密码设置 -->
        <div class="set-terminal-pwd">  
            <div class="terminal-pwd-title">
                <div class="title-name">
                    <div class="point-icon"></div>
                    <div>终端密码设置</div>
                </div>
                <div class="terminal-pwd-toggle">
                    <div class="toggle-title">终端密码：{{ terminalPwdStatus == true ? '开' : '关'}}</div>
                    <el-switch
                    v-model="terminalPwdStatus"
                    active-color="#ff7513"
                    inactive-color="#dcdfe6" @change="onSwitchPWDChanged">
                    </el-switch>
                </div>
            </div>
            <!-- 设置密码区域 -->
            <div class="set-area" v-show="terminalPwdStatus">
                <div class="terminal-pwd">
                    <div class="pwd-title">终端密码</div>
                    <el-input class="pwd-input" :disabled="true" autocomplete="off" :type="originalPwdType" placeholder="请输入密码" size="medium" v-model="terminalPwd"></el-input>
                    <div class="pwd-icon-container" @click="pwdIconToggle('original')" v-show="showTerminalPwdIcon">
                        <img class="pwd-icon" v-show="showOriginalPwd == true" src="/Account/images/setting/navigation/device-management/showPwd.png">
                        <img class="pwd-icon" v-show="showOriginalPwd == false" src="/Account/images/setting/navigation/device-management/hiddenPwd.png">
                    </div>
                </div>
                <div class="reset-pwd-btn" 
                    v-if="!showNewPWDContent"
                    @click="onResetPwdBtnClicked">
                    <i></i>重置密码
                </div>
                <div class="reset-pwd-content" v-if="showNewPWDContent">
                    <div class="terminal-pwd">
                        <div class="pwd-title">重置密码</div>
                        <el-input class="pwd-input" autocomplete="off" :type="resetPwdType" :autofocus="true" placeholder="请输入密码" size="medium" v-model="resetPwd"></el-input>
                        <div class="pwd-icon-container" @click="pwdIconToggle('reset')" v-show="showResetPwdIcon">
                            <img class="pwd-icon" v-show="showResetPwd == true" src="/Account/images/setting/navigation/device-management/showPwd.png">
                            <img class="pwd-icon" v-show="showResetPwd == false" src="/Account/images/setting/navigation/device-management/hiddenPwd.png">
                        </div>
                    </div>
                    <div class="reset-pwd-submit-btn">
                        <el-button type="primary" size="small" @click="onResetPwdSubmit">重 置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 学生终端应用管理 -->
        <div class="set-terminal-app">  
            <div class="terminal-app-title">
                <div class="title-wrap">
                    <div class="title-name">
                        <div class="point-icon"></div>
                        <div>学生终端应用管理</div>
                    </div>
                    <div class="terminal-app-tip">
                        <span>允许本班学生使用的程序</span>
                    </div>
                </div>
                <div class="terminal-pwd-toggle">
                    <div class="toggle-title">终端应用：{{ terminalAPPStatus == true ? '开' : '关'}}</div>
                    <el-switch
                    v-model="terminalAPPStatus"
                    active-color="#ff7513"
                    inactive-color="#dcdfe6" @change="onSwitchAppChanged">
                    </el-switch>
                </div>
            </div>
            <!-- 设置区域 -->
            <div class="set-area" v-show="terminalAPPStatus">
                <div class="terminal-app">
                    <div class="app-title">选择机型</div>
                    <div class="select-device">
                        <el-select v-model="selectedSysDeviceName" placeholder="请选择机型" size="small" class="select-type-one" @change="onSysDeviceChange">
                            <el-option
                            v-for="item,index in sysTemDeviceList"
                            :key="index"
                            :label="item.BName"
                            :value="item.BName">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!-- 系统应用 -->
                <div> 
                    <div class="app-border-title">系统应用</div>
                    <div class="app">
                        <div class="system-app-container">
                            <div class="system-app-option" v-for="app,index in sysTemDeviceAppsList" :key="index">
                                <img v-show="!app.IsUse" @click="onSysTemDeviceAppCheck(app, true)" class="check-icon" src="/Account/images/setting/navigation/device-management/unchecked.png">
                                <img v-show="app.IsUse" @click="onSysTemDeviceAppCheck(app, false)" class="check-icon" src="/Account/images/setting/navigation/device-management/checked.png">
                                <img class="app-icon" :src="getAppIcon(app.Icon)">
                                <div class="app-name">{{ app.Chs }}</div>
                            </div>
                            <div v-if="!isValidArray(sysTemDeviceAppsList)">
                                暂无应用
                            </div>
                        </div>
                    </div>
                    <el-button type="primary" class="save-button" round @click="onSysTemDeviceAppSubmit">确定</el-button>
                </div>
                <!-- 校本应用 -->
                <div>
                    <span class="app-border-title">校本应用</span>
                    <div class="app school-app">
                        <div class="school-app-container">
                            <!-- 编辑图标区域 -->
                            <div class="school-btn-area">
                                <div v-show="!isClassAppEditing" class="school-icon school-app-edit" @click="onEditClassClicked">
                                    <img class="icon-img" src="/Account/images/setting/navigation/device-management/edit.png">
                                    <div>编辑</div>
                                </div>
                                <div v-show="isClassAppEditing" class="school-icon school-app-edit complete-icon" @click="onEditClassClicked">
                                    <div>完成</div>
                                </div>
                                <div class="school-icon source-add" @click="resourceAdd">
                                    <img class="icon-img" src="/Account/images/setting/navigation/device-management/add.png">
                                    <div>资源库添加</div>
                                </div>
                                <cloud-upload class="school-icon local-add" ref="appFile" :config="cloudUploadConfig" @beforeUpload="beforeApkUpload">
                                    <div class="local-add-slot">
                                        <img class="icon-img local-add-icon" src="/Account/images/setting/navigation/device-management/add.png">
                                        <div class="local-add-btn">本地添加</div>
                                    </div>
                                </cloud-upload>
                            </div>
                            <!-- 应用展示区域 -->
                            <div class="system-app-container school-app-area">
                                <div class="system-app-option" v-for="item in classDeviceAppsList" :key="item.AAIdx" @click="onEditAppItemClick(item)">
                                    <!-- 编辑状态 -->
                                    <img v-show="isClassAppEditing" class="check-icon" src="/Account/images/setting/navigation/device-management/delete.png" @click="onDeleteClassApp(item)">
                                    <!-- 非编辑状态 -->
                                    <img v-show="!isClassAppEditing && !item.IsSelect" @click.stop="onClassAppItemChecked(item, true)" class="check-icon" src="/Account/images/setting/navigation/device-management/unchecked.png">
                                    <img v-show="!isClassAppEditing && item.IsSelect" @click.stop="onClassAppItemChecked(item, false)" class="check-icon" src="/Account/images/setting/navigation/device-management/checked.png">
                                    <img class="app-icon" :src="item.PreviewUrl">
                                    <div class="app-name">{{  item.AppName  }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-button v-show="classTemDeviceAppSubmitFlag" type="primary" class="save-button" round @click="onClassTemDeviceAppSubmit">确定</el-button>
                </div>
            </div>
        </div>
        <app-info-handler :config="appInfoHandlerConfig" :isEditApp="isEditApp" @onCancelClicked="onAppInfoCancelClicked" @submitSucc="submitSucc"></app-info-handler>
    </div>
</div>
</template>

<script>
import { 
    GET_SCHOOL_PERIOD_GRADE,
    GET_GRADE_CLASS_LIST,
    GET_CLASS_INFO_JSON,
    GET_APPPWD_JSON,
    APP_TURN_ON_SET_JSON,
    SET_APP_PWD_JSON,
    GET_BOYD_APPITEM_JSON,
    SET_MYCLASS_APPSET_JSON,
    GET_CLASS_ATTACHMENT_APPSJSON,
    DEL_ATTACHMENT_APPS_CLASS,
    GET_APP_INFO,
    SET_ATTACHMENT_APPS_CLASS_JSON } from "@/http/api";
import '@/styles/element-variables.scss';   // element-ui主题色
import CloudUpload from '@/components/setting/DeviceManagement/CloudUpload';
import AppInfoHandler from '@/components/setting/DeviceManagement/AppInfoHandler';
export default {
    data() {
        return {
            selectedGradeIdx: null,     // 选择的年级
            selectedClassIdx: null,     // 选择的班级
            gradeList:[],               // 年级列表
            classList:[],               // 班级列表
            currSelClassDetail: null,   // 当前选定的班级的详细信息
            terminalPwd: null,          // 终端密码
            terminalPwdStatus: false,   // 终端密码是否开启
            resetPwd: null,             // 终端重置密码
            showOriginalPwd: false,     // 是否显示原来的密码
            showResetPwd: false,        // 是否显示重置的密码
            showNewPWDContent: false,   // 是否显示重新输入新密码输入框
            originalPwdType: 'password',// 终端密码输入框的类型，用于控制密码显隐
            resetPwdType: 'password',   // 重置密码输入框的类型，用于控制密码显隐
            terminalAPPStatus: false,   // 终端应用显示开关
            sysTemDeviceList: [],       // 系统应用列表
            selectedSysDeviceName: "",  // 终端机型Name
            sysTemDeviceAppsList: [],   // 终端机型对应系统应用列表
            classDeviceAppsList: [],    // 终端机型对应班级应用列表
            isClassAppEditing: false,   // 校本应用是否处于编辑状态
            classTemDeviceAppSubmitFlag: true,      // 学生终端应用管理-校本应用：下方的确认按钮
            cloudUploadConfig: {
                uploadDirect: false,
            },
            appInfoHandlerConfig: {
                appInfo: null, // 编辑已有的app信息
                file: null,    // 本地上传新文件
                dialogVisible: false,
            },
            isEditApp: false   // 是否是二次编辑应用信息
        }
    },
    components: {
        CloudUpload,
        AppInfoHandler
    },
    computed: {
        // 是否是班主任
        isMaster(){
            return this.currSelClassDetail.TeacherID == this.loadAccount().userid
        },
        showTerminalPwdIcon(){   // 显示终端密码后面的图标
            return this.terminalPwd != null && this.terminalPwd != "" 
        },
        showResetPwdIcon(){   // 显示重置密码后面的图标
            return this.resetPwd != null && this.resetPwd != ""
        }
    },
    methods:{
        // 点击编辑班级应用
        onEditAppItemClick(item){
            this.isEditApp = true
            if(!this.isClassAppEditing){  // 没有处于编辑状态时，才打开应用信息
                let param = {
                    aaIdx: item.AAIdx,
                    page: 0,
                    session: this.getSession()
                }
                // console.log("点击的这一项的信息",item)
                // console.log("获取应用具体信息，参数在后面",param)
                // debugger
                // 获取这个app的具体信息
                GET_APP_INFO(this.$qs.stringify(param)).then((info)=>{
                    let result = info.data.result[0]
                    this.appInfoHandlerConfig.appInfo = result
                    this.appInfoHandlerConfig.dialogVisible = true
                })
            }
        },
        // app 信息关闭事件
        onAppInfoCancelClicked(){
            this.appInfoHandlerConfig.file = null
            this.appInfoHandlerConfig.dialogVisible = false
        },
        submitSucc(){   // 校本应用添加成功
            this.fetchClassApp()    // 成功时刷新应用信息     
        },
        // apk 上传拦截器
        beforeApkUpload(file){
            this.isEditApp = false     // 本地添加
            // console.log("上传的文件信息",file)
            // console.log("上传的文件类型",file.type)
            if(file.type == "application/vnd.android.package-archive"){  // 只能上传apk格式
                this.appInfoHandlerConfig.file = file
                this.appInfoHandlerConfig.dialogVisible = true
            }else{
                this.$message.error('文件格式不正确');
            }
            
        },
        // 班级应用选中状态切换
        onClassAppItemChecked(item, status){
            item.IsSelect = status
        },
        // 班级删除应用
        onDeleteClassApp(item){
            this.$confirm('确认删除应用?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let currSelClassDetail = this.currSelClassDetail
                let param = {
                    'session': this.getSession(),
                    'page': 0,
                    'periodidx': currSelClassDetail.PeriodIdx,
                    'schoolidx': currSelClassDetail.SchoolIdx,
                    'gradeidx': currSelClassDetail.GradeIdx,
                    'classIdx': currSelClassDetail.ClassIdx,
                    'aaIdx': item.AAIdx
                };
                DEL_ATTACHMENT_APPS_CLASS(this.$qs.stringify(param)).then(info=>{
                    if (info.data.ReturnCode == 1) {
                        this.$alert('修改成功', '提示', {
                            confirmButtonText: '确定',
                        })
                        
                        // 删除班级应用后页面刷新
                        let deleteIndex = this.classDeviceAppsList.findIndex(item=>{
                            return item.AAIdx == param.aaIdx
                        })
                        this.classDeviceAppsList.splice(deleteIndex, 1)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 班级应用点击编辑
        onEditClassClicked(){
            this.isClassAppEditing = !this.isClassAppEditing    // 编辑和完成状态切换
            this.classTemDeviceAppSubmitFlag = !this.classTemDeviceAppSubmitFlag  // 编辑状态时隐藏确认按钮
        },
        // 切换系统应用机型
        onSysDeviceChange(id){
            let device = this.sysTemDeviceList.find(item=>{
                return item.BTypeIdx = id
            })
            let typename = device.type // 设备类型
            typename = typename == 'all' ? 'android' : typename
            
            this.fetchSysTemApp(typename)
            this.fetchClassApp(typename)
        },
        // 系统应用 check 事件
        onSysTemDeviceAppCheck(app, state){
            app.IsUse = state
        },
        // 系统应用 保存 事件
        onSysTemDeviceAppSubmit(){
            let param = this.buildCommonParam()
            let appList = []
            this.sysTemDeviceAppsList.forEach((item)=>{
                if(item.IsUse){
                    appList.push(item.ASIIdx)
                }
            })
            param.appList = JSON.stringify(appList)
            SET_MYCLASS_APPSET_JSON(this.$qs.stringify(param)).then((info)=>{
                if (info.data.ReturnCode == 1) {
                    this.$alert('修改成功', '提示', {
                        confirmButtonText: '确定',
                    })
                }
            })
        },
        // 班级应用 保存 事件
        onClassTemDeviceAppSubmit(){
            var selectApps = []
            this.classDeviceAppsList.forEach(item=>{
                if(item.IsSelect){
                    selectApps.push(item.AAIdx)
                }
            })
            var message = '您将开放'+ selectApps.length +'个应用给' + this.currSelClassDetail.ClassName;
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let param = {
                    session : this.getSession(),
                    page: 1,
                    aaList : JSON.stringify(selectApps),
                    classIdx : this.currSelClassDetail.ClassIdx,
                    schoolidx: this.currSelClassDetail.SchoolIdx,
                    periodidx: 0,
                    gradeidx : 0
                }
                SET_ATTACHMENT_APPS_CLASS_JSON(this.$qs.stringify(param)).then((info)=>{
                    if (info.data.ReturnCode == 1) {
                        this.$alert('保存成功', '提示', {
                            confirmButtonText: '确定',
                        })
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 系统图片地址
        // "/Account/images/cc-app-browser.png"
        getAppIcon(iconath){
            let url = ""
            if (this.isValid(iconath)) {
                var arr = iconath.split('/');
                url = "/Account/images/setting/navigation/device-management/sysicons/" + arr[arr.length - 1];
            }
            return url;
        },
        // 公共参数
        buildCommonParam(){
            let currSelClassDetail = this.currSelClassDetail
            return {
                classid: currSelClassDetail.ClassIdx,
                gradeidx: currSelClassDetail.GradeIdx,
                periodidx: currSelClassDetail.PeriodIdx,
                schoolidx: currSelClassDetail.SchoolIdx,
                page: 0,
                session: this.getSession(),
            }
        },
        // 终端密码 switch 切换事件
        onSwitchPWDChanged(){
            if (this.isMaster) { // 非班主任提示
                let param = this.buildCommonParam()
                param.flag = 1 // 控制密码传1 控制应用传2
                param.states = this.terminalPwdStatus ? 1 : 0
                APP_TURN_ON_SET_JSON(this.$qs.stringify(param)).then(info=>{
                    // 接口失败再次调整状态
                    if (info.data.ReturnCode != 1) {
                        this.terminalPwdStatus = !this.terminalPwdStatus
                    }
                })
            }else{
                this.terminalPwdStatus = false
                this.$alert('对不起，您暂无权限操作。班主任和学校管理员可以全面管理学生设备，请联系学校管理员获取相应权限。', '提示', {
                    confirmButtonText: '确定',
                })
            }
        },
        onSwitchAppChanged(){
            if (this.isMaster) { // 非班主任提示
                let param = this.buildCommonParam()
                param.flag = 2 // 控制密码传1 控制应用传2
                param.states = this.terminalAPPStatus ? 1 : 0
                APP_TURN_ON_SET_JSON(this.$qs.stringify(param)).then(info=>{
                    // 接口失败再次调整状态
                    if (info.data.ReturnCode != 1) {
                        this.terminalAPPStatus = !this.terminalAPPStatus
                    }else{
                        this.fetchSysTemApp()
                        this.fetchClassApp()
                    }
                })
            }else{
                this.terminalAPPStatus = false
                this.$alert('对不起，您暂无权限操作。班主任和学校管理员可以全面管理学生设备，请联系学校管理员获取相应权限。', '提示', {
                    confirmButtonText: '确定',
                })
            }
        },
        // 密码可见切换事件
        pwdIconToggle(type){   // 密码输入框显隐状态切换
            if(type == 'original'){  // 原来密码
                this.showOriginalPwd = !this.showOriginalPwd
                this.originalPwdType == 'password' ? this.originalPwdType = '' : this.originalPwdType = 'password'
            }else if(type == 'reset'){  // 重置密码
                this.showResetPwd = !this.showResetPwd
                this.resetPwdType == 'password' ? this.resetPwdType = '' : this.resetPwdType = 'password'
            }
            this.showPwd = !this.showPwd
        },
        // 重置终端密码提交事件
        onResetPwdSubmit(){
            if(this.resetPwd == null || this.resetPwd == ""){
                this.$message({
                    showClose: true,
                    message: '重置密码不能为空',
                    type: 'warning'
                });
            }else{
                var old_pwd = this.terminalPwd;
                var new_pwd = this.resetPwd;
                var reg = /^[a-zA-Z0-9_]*$/;
                if (!reg.test(new_pwd)) {
                    this.$alert('密码由字母、数字、下划线组成', '提示', {
                        confirmButtonText: '确定'
                    })
                    return;
                }
                let currSelClassDetail = this.currSelClassDetail
                let param = {
                    classid: currSelClassDetail.ClassIdx,
                    gradeidx: currSelClassDetail.GradeIdx,
                    periodidx: currSelClassDetail.PeriodIdx,
                    schoolidx: currSelClassDetail.SchoolIdx,
                    page: 0,
                    session: this.getSession(),
                    oldpwd: old_pwd,
                    pwd: new_pwd,
                    op: this.ismater ? 0 : 1 // 0 代表修改旧密码，1代表新增密码
                }
                SET_APP_PWD_JSON(this.$qs.stringify(param)).then((info)=>{
                    if (info.data.ReturnCode == 1) {
                        // this.$alert('修改成功', '提示', {
                        //     confirmButtonText: '确定',
                        // })
                        this.$message({
                            showClose: true,
                            message: '修改成功',
                            type: 'success'
                        });
                        this.terminalPwd = new_pwd
                        this.resetPwd = ""
                    }
                })
            }
        },
        // 获取年级列表
        fetchGradeList(next) {
            let param = {
                'session': this.getSession(),
                'page': 0,
                'schoolidx': this.loadAccount().schoolidx,
                'onlyme': true,
            }
            GET_SCHOOL_PERIOD_GRADE(this.$qs.stringify(param)).then(info=>{
                let result = info.data.result
                if (this.isValidArray(result)) {
                    var gradeList = [];
                    for (var i = 0; i < result.length; i++) {
                        var periodItem = result[i];
                        gradeList = gradeList.concat(periodItem.ChildList);
                    }
                    this.gradeList = gradeList;
                    this.selectedGradeIdx = gradeList[0].Idx
                }
                next && next()
            });
        },
        // 获取对应年级的班级列表
        fetchClassList(){
            let param = {
                'session': this.getSession(),
                'page': 0,
                'schoolidx': this.loadAccount().schoolidx,
                'gradeidx': this.selectedGradeIdx,
                'onlyme': true, // onlyme 如果当前登录者是教师身份 则为true 如果是管理员身份 则为false
            };
            GET_GRADE_CLASS_LIST(this.$qs.stringify(param)).then(info=>{
                let result = info.data.result
                this.classList = result
                this.selectedClassIdx = result[0].Idx
                this.fetchClassInfo()
            });
        },
        // 重置密码按钮事件 展示新密码区域
        onResetPwdBtnClicked(){
            this.showNewPWDContent = true
        },
        // 切换年级
        onGradeChange(){
            this.terminalPwdStatus = false  // 切换的时候把终端密码关闭
            this.terminalAPPStatus = false  // 切换的时候把终端应用关闭
            this.fetchClassList()
        },
        // 切换班级
        onClassChange(){
            this.terminalPwdStatus = false  // 切换的时候把终端密码关闭
            this.terminalAPPStatus = false  // 切换的时候把终端应用关闭
            this.fetchClassInfo()
        },
        // 获取当前班级详细信息
        fetchClassInfo(){
            let param = {
                classidx: this.selectedClassIdx,
                page: 0,
                session: this.getSession()
            }
            GET_CLASS_INFO_JSON(this.$qs.stringify(param)).then(info=>{
                let result = info.data.result
                if(this.isValidArray(result)){
                    this.currSelClassDetail = result[0]
                    this.getAppWd()
                }
            })
        },
        // 获取系统应用
        fetchSysTemApp(){
            let param = this.buildCommonParam()
            param.btypename = this.selectedSysDeviceName || "默认"
            GET_BOYD_APPITEM_JSON(this.$qs.stringify(param)).then(info=>{
                let result = info.data.result
                if (this.isValidArray(result)) {
                    let sysTemDeviceList = result[0].ChildList
                    if(this.isValidArray(sysTemDeviceList)){
                        sysTemDeviceList.forEach(item=>{
                            switch (item.BName) {
                                case '默认':
                                    item.type = 'all';
                                    break;
                                case '汉之派':
                                case '联想 A1070':
                                case 'Yoga 2':
                                case '1050LC':
                                    item.type = 'android';
                                    break;
                                default:
                                    item.type = 'android';
                                    break;
                            }
                        })
                    }
                    this.sysTemDeviceList = sysTemDeviceList
                    if(this.selectedSysDeviceName == ""){
                        this.selectedSysDeviceName = this.sysTemDeviceList[0].BName
                    }
                    this.sysTemDeviceAppsList = result[1].ChildList;
                } else {

                }
            })
        },
        // 获取班级应用
        fetchClassApp(typename){
            let param = {
                'session':  this.getSession(),
                'classIdx': this.selectedClassIdx,
                'platform': typename || 'android',
                'schoolidx': 0,
                'periodidx': 0,
                'gradeidx': 0
            }
            GET_CLASS_ATTACHMENT_APPSJSON(this.$qs.stringify(param)).then(info=>{
                let result = info.data.result
                this.classDeviceAppsList = result
            })
        },
        // 获取班级开关状态（密码开关、终端应用开关）
        getAppWd(){
            let currSelClassDetail = this.currSelClassDetail
            let param = {
                classid: currSelClassDetail.ClassIdx,
                gradeidx: currSelClassDetail.GradeIdx,
                periodidx: currSelClassDetail.PeriodIdx,
                schoolidx: currSelClassDetail.SchoolIdx,
                page: 0,
                session: this.getSession()
            }
            GET_APPPWD_JSON(this.$qs.stringify(param)).then(info=>{
                let result = info.data.result
                // 班主任
                if(this.isMaster){
                    var item = result[0];
                    var pwd = item.Pwd;

                    var state = item.Sates;         // 密码修改开关 0关1开
                    var statesApp = item.StatesApp; // 应用管理开关 0关1开
                    this.terminalPwdStatus = state == 1 ? true : false
                    this.terminalPwd = pwd;
                    this.terminalAPPStatus = statesApp == 1 ? true : false
                    if(this.terminalAPPStatus){
                        this.fetchSysTemApp()
                        this.fetchClassApp()
                    }
                }else{
                    this.terminalPwdStatus = false;
                    this.terminalPwd = "";
                }
            })
        },
        // 校本应用-从资源库添加
        resourceAdd(){
            // console.log("点击从资源库添加")
            var url = this.getNavigationUrl('res.yyzy') == "" ? this.getNavigationUrl('res.yyzy.link') : this.getNavigationUrl('res.yyzy');
            var device = sessionStorage['device'];
            // console.log("device",device)
            var embed = this.Cookies.get('embed');
            // console.log("url",url)
            // console.log("device",device)
            // console.log("embed",embed)
            if(this.isValid(url) && url != '') {
                if(this.isValid(device) || this.isValid(embed)) {
                    url += '?embed=true';
                }
                location.href = url;
            } else {
                this.$message.error('对不起，您没有相应权限');
            }
        }
    },
    created(){
        this.fetchGradeList(()=>{
            this.fetchClassList()
        });
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/account-setting.scss';   // 颜色统一定义
.container{
    background-color: $bg-color2;
    border-radius: 4px;
    .title{   // 标题
        padding-top: 24px;
        padding-left: 32px;
        padding-right: 24px;
        font-size: 20px;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .title-tip{
            font-size: 12px;
            font-weight: 400;
            color: #A9AEB8;
        }
    }
    .line{   // 分割线
        margin-top: 15px;
        margin-bottom: 32px;
    }
    .content{ // 内容区
        padding-left: 32px;
        padding-right: 24px;
        box-sizing: border-box;
        width: 100%;
        padding-bottom: 24px;
        margin-bottom: 24px;
        .select-class{  // 选择年级班级区域
            display: flex;
            align-items: center;
            ::v-deep .el-input{  // 选择框字体大小
                font-size: 14px;
            }
            .select-type-one{  // 第一行选择框样式
                width: 136px;
                margin-right: 16px;
                font-size: 14px;
            }
        }
        .set-terminal-pwd{  // 终端密码设置区域
            margin-top: 64px;
            .terminal-pwd-title{   // 设置终端密码标题区域
                display: flex;
                justify-content: space-between;
                align-items: center;
                .title-name{
                    font-weight: 500;
                    display: flex;
                    .point-icon{  // 标题前边的小橘点
                        width: 6px;
                        height: 6px;
                        background-color: #ff7513;
                        border-radius: 50%;
                        margin: 8px 8px 8px 0;
                    }
                }
            }
            .terminal-pwd-toggle{  // 终端密码开关
                display: flex;
                font-size: 14px;
                .toggle-title{
                    margin-right: 16px;
                }
            }
            .set-area{   // 密码设置区域
                margin-top: 24px;
                .terminal-pwd{   // 每一行左侧标题
                    display: flex;
                    align-items: center;
                    margin-bottom: 24px;
                    .pwd-title{
                        width: 56px;
                        height: 22px;
                        font-size: 14px;
                        margin-right: 16px;
                        color: #A9AEB8;
                    }
                    .pwd-input{   //密码输入框
                        width:384px
                    }
                    .pwd-icon-container{  // 密码输入框右侧图标
                        margin-left: 16px;
                        cursor: pointer;
                        .pwd-icon{
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
                .reset-pwd-btn{
                    width: 100px;
                    height: 32px;
                    background: rgba(255,117,19,0.04);
                    border: 1px solid #FF7513;
                    border-radius: 2px;
                    font-size: 14px;
                    color: #FF7513;
                    line-height: 32px;
                    position: relative;
                    text-align: center;
                    padding-left: 26px;
                    box-sizing: border-box;
                    cursor: pointer;
                    margin-left: 72px;
                    i{
                        background-image: url("/Account/images/setting/navigation/device-management/reset.png");
                        width: 16px;
                        height: 16px;
                        background-repeat: no-repeat;
                        background-size: contain;
                        display: block;
                        position: absolute;
                        left: 12px;
                        top: 8px;
                    }
                }
                .reset-pwd-content{
                    .reset-pwd-submit-btn{
                        margin-left: 72px;
                        ::v-deep .el-button--small{  // 选择框字体大小
                            padding:8px 15px;
                            font-size:14px
                        }
                    }
                }
            }
        }
        .set-terminal-app{  // 学生终端应用设置区域
            margin-top: 64px;
            .terminal-app-title{   // 设置终端应用标题区域
                display: flex;
                justify-content: space-between;
                align-items: center;
                .title-wrap{
                    display: flex;
                    .title-name{
                        font-weight: 500;
                        display: flex;
                        .point-icon{  // 标题前边的小橘点
                            width: 6px;
                            height: 6px;
                            background-color: #ff7513;
                            border-radius: 50%;
                            margin: 8px 8px 8px 0;
                        }
                    }
                    .terminal-app-tip{  // 标题右侧小的提示文字
                        color: #A9AEB8;
                        height: 18px;
                        margin-left: 16px;
                        font-size: 12px;
                        position: relative;
                        top: 3px;
                    }
                }
            }
            .terminal-pwd-toggle{  // 终端密码开关
                display: flex;
                font-size: 14px;
                .toggle-title{
                    margin-right: 16px;
                }
            }
            .set-area{   // 应用设置区域
                margin-top: 24px;
                .terminal-app{   // 每一行左侧标题
                    display: flex;
                    align-items: center;
                    margin-bottom: 3px;
                    .app-title{
                        width: 56px;
                        height: 22px;
                        font-size: 14px;
                        margin-right: 16px;
                        color: #A9AEB8;
                    }
                    .select-device{  // 选择机型
                        width: 168px;
                    }
                    .pwd-input{   //密码输入框
                        width:384px
                    }
                }
                .app-border-title {  // 系统应用和校本应用
                    position: relative;
                    top: 10px;
                    left: 705px;
                    background: white;
                    width: 62px;
                    height: 20px;
                    padding: 0 5px;
                    color: #A9AEB8;
                    font-size: 14px;
                }
                .app{   // 系统应用
                    // background-color: #87ceeb47;
                    border: 2px solid #E5E6EB;
                    border-radius: 4px;
                    padding: 34px 24px;
                    margin-bottom: 12px;
                    display: flex;
                    .system-app-container{   // 系统应用
                        // background-color: bisque;
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        .system-app-option{   // 每一项
                            display: flex;
                            align-items: center;
                            width: 22%;
                            height: 32px;
                            margin-bottom: 24px;
                            cursor: pointer;
                            .check-icon{   // 选择和未选的图标
                                cursor: pointer;
                                width: 16px;
                                height: 16px;
                                margin-right: 14px;
                            }
                            .app-icon{  // 应用图标
                                width: 28px;
                                height: 28px;
                                margin-right: 14px;
                            }
                            .app-name {  // 应用的名称
                                min-width: 42px;
                                font-size: 14px;
                            }
                        }
                        .system-app-option:not(:nth-child(4n)){
                            margin-right: calc(12% / 3);
                        }
                        // 最后一行没有bottom
                        .system-app-option:nth-child(4n+1):nth-last-child(-n+4), .system-app-option:nth-child(4n+1):nth-last-child(-n+4)~.system-app-option{
                            margin-bottom: 0;
                        }
                    }
                    .school-app-container{   // 校本应用
                        width: 100%;
                        .school-btn-area{   // 三个按钮区域
                            display: flex;
                            .school-icon{
                                display: flex;
                                align-items: center;
                                margin-right: 16px;
                                height: 30px;
                                border: 1px solid #E5E6EB;
                                background-color: #F7F8FA;
                                border-radius: 4px;
                                font-size: 14px;
                                cursor: pointer;
                                .icon-img{ // 每一个按钮里的小图标
                                    width: 15px;
                                    height: 15px;
                                    margin-left: 9px;
                                    margin-right: 5px;
                                }
                            }
                            .complete-icon{  // 完成按钮
                                justify-content: center;
                                color: white;
                                background-color: #ff7513;
                                border-color: #ff7513;
                            }
                            .school-app-edit {  // 编辑按钮
                                width: 72px;
                            }
                            .source-add {  // 资源库添加按钮
                                width: 114px;
                            }
                            .local-add {  // 本地添加
                                width: 100px;
                                ::v-deep .el-upload--picture-card{
                                    border: none;
                                    background-color: initial;
                                }
                                ::v-deep .el-upload--picture-card:hover{
                                    border-color: initial;
                                    color: initial;
                                }
                                .local-add-slot{
                                    display: flex;
                                    align-items: center;
                                    width: 98px;
                                    height: 28px;
                                    position: relative;
                                    line-height: 28px;
                                    background-color: #f7f8fa;
                                }
                                .local-add-icon{  // 本地添加的图标 + 号
                                    margin-top: 1px;
                                }
                                .local-add-btn{
                                    margin-top: 3px;
                                    color: black;
                                }

                            }
                        }
                        .school-app-area {   // 校本应用显示区域
                            width: 100%;
                            margin-top: 24px;
                        }
                    }
                }
                .school-app{   // 校本应用特殊
                    padding: 24px 24px 32px 24px;
                    box-sizing: border-box;
                    min-height: 256px;
                    margin-bottom: 0;
                    margin-bottom: 12px;
                }
            }
        }
    }
    .save-button{
        display: block;
        margin: 0 auto;
    }
}
</style>